<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <h2 class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.ATYPISCHE_STILLE_BETEILIGUNG.TITEL' | translate }}</h2>

  <div class="form-row mb-3x">
    <input class="form-check-input" datevMessagePath="isAtypisch{{objectId}}"
           formControlName="isAtypisch"
           id="isAtypisch" type="checkbox"
           utilsCheckValidity utilsControlState utilsValidationMessage/>
    <label class="form-check-label"
           for="isAtypisch">{{ 'COMMON_UI.FRAGEBOGEN.ATYPISCHE_STILLE_BETEILIGUNG.CHECK' | translate }}
    </label>
  </div>

</form>
